// First visit on this device: the store opens on the welcome page once, then goes straight to browsing.
// Kept in localStorage, so clearing site data (or a private window) shows it again, which is harmless.

const KEY = "walashy.welcomed";

export function hasSeenWelcome(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return true; // storage blocked: never trap anyone on the welcome page
  }
}

export function markWelcomeSeen() {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    // ignore: storage blocked
  }
}
